import React, {useMemo, Fragment} from 'react';
import {Edit, Icon, Breadcrumbs, Link, Layout, Form, Textarea, Date, Tags, Notes, Button, Redirect, List} from 'components';
import {redirect, debounce, get, useWindowSize, useNamedSelector, useParams, useSelector} from 'helpers';
import {forbid} from 'store/session';
import {notes, calendar, permissions} from 'store';
import {Note} from 'types';

export function EditForm() {
  const {id} = useParams<{id: string}>();
  const {today} = useSelector(calendar.days);
  const {canAdd} = useSelector(permissions.list);
  const {note, category, saved} = useNamedSelector('notes.details', {id, context: 'notes'});
  const {height} = useWindowSize();

  const initialValues = useMemo(() => {
    if (note) {
      return {
        ...note,
        category: get(category, 'name', ''),
      }
    }
    return {
      category: '',
      text: '',
      date: today.unix(),
      tagIds: '',
    }
  }, [id]);

  return (
    <Fragment>
      {id && !note && <Redirect to="/notes/" />}
      <Form initialValues={initialValues} onChange={save}>
        <Layout.Header container="large" justified>
          <Breadcrumbs>
            <Link to="/notes/">Notes</Link>
            <span>
              <b>{id ? 'Edit' : 'Add'} Note </b>
              {!saved && <Icon className="secondary" name="spinner" />}
            </span>
          </Breadcrumbs>
          {id &&
            <Button className={['secondary', 'small']} icon="plus" to={canAdd.notes ? '/notes/add/' : undefined} onClick={canAdd.notes ? undefined : forbid}>
              Add Note
            </Button>
          }
        </Layout.Header>
        <List small-gutter>
          <Edit name="title" placeholder="Title" bold autoFocus={!id} />
          <Textarea name="text" placeholder="Enter note.." minRows={Math.round((height - 400) / 32)} />
          <Notes.CategoriesDropdown name="category" label="Category" />
          <Date name="date" label="Date" required />
          <Tags name="tagIds" />
        </List>
      </Form>
    </Fragment>
  );
}

const save = debounce((note: Note) => {
  if (note.id) {
    notes.dispatch.update(note);
  } else if (note.text || note.title) {
    const action = notes.dispatch.update(note);
    redirect(`/notes/${action.note.id}/`, true);
  }
}, 200);
